import DashBoard from "@/modules/crm/dashboard";

export default function CRM() {
  return (
    <main>
      <div>
        <DashBoard />
      </div>
    </main>
  );
}
